// Helper for navigation actions across pages
export const NAV_ACTIONS = {
  HOME: { type: 'scroll', target: 'top' },
  ABOUT: { type: 'scroll', target: 'about' },
  'GRAPHIC DESIGN': { type: 'route', target: '/graphic-design' },
  'UI / UX': { type: 'route', target: '/ui-ux' },
  'AI CREATIVE': { type: 'route', target: '/ai-creative' },
  TOOLS: { type: 'scroll', target: 'tools' },
  SERVICES: { type: 'scroll', target: 'services' },
  CONTACT: { type: 'route', target: '/contact' },
};

export const scrollToSection = (id) => {
  if (id === 'top') {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    return;
  }
  const el = document.getElementById(id);
  if (el) {
    el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
};
